// Logo configuration for Lucent HR System
// Using high-quality logo with proper sizing

export const LOGO_URL = "/branding/logo.png";

// Logo sizes for different contexts
export const LOGO_SIZES = {
  login: 'h-32 w-auto', // Large for login page
  header: 'h-10 w-auto', // Medium for header
  sidebar: 'h-8 w-auto', // Small for sidebar
  favicon: 'h-6 w-6', // Tiny for favicon
};

// Brand colors
export const BRAND_COLORS = {
  primary: '#655dc6',
  primaryDark: '#544cb0',
  primaryLight: '#C4BFF0',
  background: '#F2F0FA',
  border: '#C4BFF0',
};
